import React from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
import { Button, Dialog } from 'oned';
import moment from 'moment';
var AvailabilityDialog = inject(AvailabilityBusiness)(observer(function (props) {
    var isSkip = props.isSkip, isSwitchToFlexible = props.isSwitchToFlexible, isSwitchToLimited = props.isSwitchToLimited, setAvailabilityParams = props.setAvailabilityParams, clearAvailabilityData = props.clearAvailabilityData, next = props.next, switchToFlexible = props.switchToFlexible, switchToLimited = props.switchToLimited;
    var switchStep = function () {
        var slaStartTime = props.slaStartTime;
        if (isSwitchToFlexible) {
            switchToFlexible();
        }
        else {
            switchToLimited();
        }
        setAvailabilityParams('calendarDate', moment(slaStartTime));
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Dialog, { visible: isSkip, title: "Skip Availability?", closable: true, destroyOnClose: true, onClose: function () {
                setAvailabilityParams('isSkip', false);
            }, animation: "zoom", maskAnimation: "fade", hasFooter: true, className: "availability rsp-body", footer: React.createElement("div", { className: 'd-flex justify-content-end align-items-center' },
                React.createElement(Button, { type: 'primary', tag: "Skip.Confirm", onClick: function () {
                        clearAvailabilityData();
                        setAvailabilityParams('isSkip', false);
                        next();
                    } }, "Confirm")) },
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("b", { className: 'title f24' }, "Skip adding available times")),
                React.createElement("div", { className: 'f16 pt-2 pb-5' }, "By not adding days and times that work, the technician will suggest times that work best for them."))),
        React.createElement(Dialog, { visible: isSwitchToFlexible || isSwitchToLimited, title: "Switch to " + (isSwitchToLimited ? 'Limited?' : '') + (isSwitchToFlexible ? 'Flexible?' : ''), closable: true, destroyOnClose: true, onClose: function () {
                setAvailabilityParams('isSwitchToLimited', false);
                setAvailabilityParams('isSwitchToFlexible', false);
                setAvailabilityParams('isStay', true);
            }, animation: "zoom", maskAnimation: "fade", hasFooter: true, className: "availability rsp-body", footer: React.createElement("div", { className: 'd-flex justify-content-end align-items-center' },
                React.createElement(Button, { type: 'secondary', tag: "Skip.Stay", onClick: function () {
                        setAvailabilityParams('isSwitchToLimited', false);
                        setAvailabilityParams('isSwitchToFlexible', false);
                        setAvailabilityParams('isStay', true);
                    } },
                    "Stay ",
                    isSwitchToFlexible ? 'Limited' : '',
                    isSwitchToLimited ? 'Flexible' : ''),
                React.createElement("div", { className: 'pl-4' }),
                React.createElement(Button, { type: 'primary', tag: "Skip.Switch", onClick: function () {
                        switchStep();
                    } },
                    "Switch to ",
                    isSwitchToFlexible ? 'Flexible' : '',
                    isSwitchToLimited ? 'Limited' : '')) },
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("b", { className: 'title f24' }, "You\u2019ve provided a lot of times")),
                React.createElement("div", { className: 'f16 pt-2 pb-5' },
                    "You have marked many times as available. Would you rather switch to ",
                    isSwitchToFlexible ? 'flexible' : '',
                    isSwitchToLimited ? 'limited' : '',
                    " availability and tell us the times that do not work?"))));
}));
export default AvailabilityDialog;
